import openGoogleSignInPopup from "api/auth/google/openGoogleSignInPopup";
import { ModalTypes } from "features/Modal/modalTypes";
import { setModal } from "features/Modal/slice";
import { useAppDispatch } from "redux/hooks";
import getAppHostName from "utils/getAppHostName";

export function useEnterWithGoogle() {
  const dispatch = useAppDispatch();

  const handleSignIn = () => {
    openGoogleSignInPopup({
      onResponse: (data) => {
        if (data.ok) {
          if (typeof data.redirectionUrl === "string") {
            window.location.href = data.redirectionUrl;
            return;
          }

          const urlSearchParams = new URLSearchParams(window.location.search);
          const subdomainInSearch = urlSearchParams.get("subdomain");
          if (subdomainInSearch) {
            const pathAfterSignIn = urlSearchParams.get("path");
            if (pathAfterSignIn) {
              window.location.href = `${getAppHostName()}/check-in?subdomain=${subdomainInSearch}&path=${pathAfterSignIn}`;
            } else {
              window.location.href = `${getAppHostName()}/check-in?subdomain=${subdomainInSearch}`;
            }
          } else {
            window.location.href = `${getAppHostName()}/check-in${
              window.location.search
            }`;
          }
        } else {
          dispatch(
            setModal({
              type: ModalTypes.UnexpectedError,
            })
          );
        }
      },
    });
  };

  return handleSignIn;
}
